import React from 'react'
import { Helmet } from 'react-helmet'

const Seo = ({ content }) => {
  const { title, titleFull, description, keywords } = content
  let setTitle = titleFull ? titleFull : `星选闪电 | ${title}`
  return (
    <Helmet>
      <title>{setTitle}</title>
      {description && <meta name='description' content={description} />}
      {keywords && <meta name='keywords' content={keywords} />}
    </Helmet>
  )
}

export default Seo
